import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./tip-notification.scss";

const TipNotification = ({ message, handleClose }) => {
  return (
    <div className="tip-notification-wrapper">
      <div className="tip-message">
        <p>{message}</p>
      </div>
      <button type="button" onClick={handleClose}>
        <FontAwesomeIcon icon="times" />
      </button>
    </div>
  );
};

TipNotification.defaultProps = {};
TipNotification.propTypes = {
  message: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default TipNotification;
